import { api } from "@slapinc/slappos-backend/api";
import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "convex/react";
import { PageContent } from "@/components/layout/page-content";
import { PermissionGuard } from "@/components/permission-guard";
import { Spinner } from "@/components/ui/spinner";
import { LineAlertsForm } from "@/features/lineAlerts/components/line-alerts-form";

export const Route = createFileRoute("/(dashboard)/settings/integrations")({
	component: () => (
		<PermissionGuard scope="organizations.update">
			<IntegrationsSettingsPage />
		</PermissionGuard>
	),
});

function IntegrationsSettingsPage() {
	const org = useQuery(api.features.organizations.web.get, {});

	if (org === undefined) {
		return (
			<PageContent title="Integrations">
				<div className="flex items-center justify-center py-12">
					<Spinner />
				</div>
			</PageContent>
		);
	}

	if (!org) return null;

	return (
		<PageContent title="Integrations">
			<div className="space-y-6">
				<div className="flex flex-col gap-2">
					<h2 className="text-2xl font-bold">LINE Alerts</h2>
					<p className="text-muted-foreground">
						Push low-stock alerts to a LINE group or 1:1 chat through the
						Messaging API. Realtime alerts fire when a sale drops stock below
						threshold, and a daily digest goes out at 08:00 Bangkok.
					</p>
				</div>

				<LineAlertsForm org={org} />
			</div>
		</PageContent>
	);
}
